import React from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

export default function Item({
  show,
  children,
  default: defaultContent = null,
  ...others
}) {
  if (isEmpty(others)) {
    return show ? children : defaultContent;
  }
  return show ? React.cloneElement(children, others) : defaultContent;
}

Item.defaultProps = {
  children: '',
  default: ''
};

Item.propTypes = {
  /**是否展示内容 */
  show: PropTypes.bool,
  /**要展示的内容 */
  children: PropTypes.element,
  /**默认内容 */
  default: PropTypes.any
};
